import React from 'react';
import ReactDOM from 'react-dom';
import Amplify from 'aws-amplify';
import awsmobile from './aws-exports';
import './index.css';
import App from './App';
import withAuthGate from './components/authGate';
import * as serviceWorker from './serviceWorker';

Amplify.configure(awsmobile);

const AuthenticatedApp = withAuthGate(App);

ReactDOM.render(<AuthenticatedApp />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
